import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from "react-router-dom";
import './references.css';
import Header2 from '../../header2/index-two';
import { Footer2 } from '../../footer2';
import { getInstitutionCustomersList } from '../../../services/instutionscustomersService';
import Spinner from 'react-bootstrap/Spinner';
import { getFilePath } from '../../../services/axiosInstance';
import usePageTracking from '../../../hooks/usePageTracking';

const References = () => {
  usePageTracking("references");
  const [institutions, setInstitutions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  const IMAGE_BASE_URL = getFilePath(`instutionscustomers/displayFile`);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    const fetchInstitutions = async () => {
      try {
        setLoading(true);
        const response = await getInstitutionCustomersList();
        if (response?.status === "OK" && Array.isArray(response.data)) {
          // Gelen datayı state'e kaydet
          setInstitutions(response.data);
        }
      } catch (error) {
        console.error("Referanslar yüklenirken hata:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInstitutions();
  }, [pathname]);

const sortedInstitutions = useMemo(() => {
  return institutions
    .filter(inst => {
      // name veya sortname içerisinde "test" kelimesi var mı bakıyoruz
      const institutionName = (inst.name || "").toLowerCase();
      const sortName = (inst.sortname || "").toLowerCase();
      
      // Eğer "test" kelimesini İÇERMİYORSA true döner (listede kalır)
      return !institutionName.includes("test") && !sortName.includes("test");
    })
    .sort((a, b) => 
      (a.sortname || a.name || "").localeCompare(b.sortname || b.name || "", 'tr')
    );
}, [institutions]);

  return (
    <div className="main-wrapper" style={{ background: '#f8fafc', minHeight: '100vh' }}>
      <Header2 />

      <section className="references-hero py-4">
        <div className="container">
          <div className="references-background mb-4">
            <div className="header-inner">
              <div className="header-title-container">
                <div className="heading-2">
                  <h2>Referanslar</h2>
                </div>
                <div className="header-description-container">
                  <p className="description-text mb-0">İdealonline ile çalışan kurumlar ve üniversiteler.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="references-grid row">
            {loading ? (
              <div className="col-12 text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-fume">Yükleniyor...</p>
              </div>
            ) : sortedInstitutions.length === 0 ? (
              <div className="col-12 text-center py-5 text-fume">Henüz referans bulunmuyor.</div>
            ) : (
              sortedInstitutions.map((inst) => {
                // Sadece fotosu olanları veya hepsini gösterebiliriz. 
                // Eğer photo null gelirse placeholder gösterir.
                const imageUrl = inst.photo 
                  ? `${IMAGE_BASE_URL}/${inst.id}/${inst.photo}`
                  : 'https://via.placeholder.com/150?text=No+Logo';

                return (
                  <div key={inst.id} className="col-6 col-sm-4 col-md-3 col-lg-3 mb-4">
                    <div className="uni-card p-3 h-100 d-flex flex-column align-items-center justify-content-center shadow-sm border-0 bg-white rounded-3">
                      <img 
                        src={imageUrl} 
                        alt={inst.name} 
                        className="img-fluid"
                        style={{ 
                          maxHeight: '80px', 
                          maxWidth: '100%', 
                          objectFit: 'contain',
                          filter: 'grayscale(10%)' // İsteğe bağlı: Hafif gri tonu daha kurumsal durabilir
                        }}
                        onMouseOver={(e) => e.currentTarget.style.filter = 'grayscale(0%)'}
                        onMouseOut={(e) => e.currentTarget.style.filter = 'grayscale(10%)'}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = 'https://via.placeholder.com/150?text=Logo';
                        }}
                      />
                      {/* Logo altında isim görmek istersen: */}
                      <span className="text-center mt-3 small fw-medium text-fume" style={{ fontSize: '0.8rem' }}>
                        {inst.name}
                      </span>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </section>

      <Footer2 />
    </div>
  );
};

export default References;